module.exports = __webpack_public_path__ + "img/IMG_8972.64a3bda0.jpg";